import React from 'react';

export default function LoadingSkeleton({ width = '100%', height = '20px', count, lines }) {
  const n = count || lines || 1;
  return (
    <>
      {Array.from({ length: n }).map((_, i) => (
        <div
          key={i}
          style={{
            width, height,
            backgroundColor: '#e5e7eb',
            borderRadius: '4px',
            marginBottom: '8px',
            animation: 'pulse 1.5s ease-in-out infinite',
          }}
        />
      ))}
    </>
  );
}
